import React from "react"
import styled from "styled-components"
import ErrorBoundary from "../ErrorBoundary"

const PageWrapper = styled.div`
    width: 100%;

    & > * {
        margin: 30px 0;
    }

    &.oneChild {
        & > * {
            margin: 0 0 30px 0;
        }
    }
`

export const TitleWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const Title = styled.div`
    font-weight: bold;
    font-size: 22px;
    line-height: 26px;
`

export const Description = styled.div`
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    white-space: break-spaces;
`

interface PageProps {
    title?: string
    sideTitle?: React.ReactNode
    description: string
    children: React.ReactNode
}

const Page: React.FC<PageProps> = ({ title, sideTitle, description, children }) => {
    return (
        <PageWrapper className={title ? "" : "oneChild"}>
            {(title || sideTitle) && (
                <TitleWrapper>
                    {title && <Title>{title}</Title>}
                    {sideTitle}
                </TitleWrapper>
            )}

            <Description>{description}</Description>
            <ErrorBoundary>{children}</ErrorBoundary>
        </PageWrapper>
    )
}

export default Page
